import { Datagrid, EditButton, Filter, List,TextField, TextInput } from 'react-admin'
import DemoVideoLinkField from './ProgramDemoVideoLinkField'
import useIsPermission from '../../hooks/useIsPermission'
import PermissionBasedActions from '../../common/PermissionBasedActionsButton'
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton'
import FormattedDateTimeField from '../../common/FormattedDateTimeField'

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const DemoVideosCategoriesList = () => {
    const { isDeletable, isWritable, isUpdatable } = useIsPermission("DEMO_VIDEOS");
    return (
        <List
            filters={<ListFilter />}
            actions={<PermissionBasedActions isWritable={isWritable} />}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <Datagrid>
                <TextField source="name" />
                <DemoVideoLinkField />
                <FormattedDateTimeField source="createdAt" />
                {isUpdatable &&
                    <EditButton />
                }
                {isDeletable &&
                    <ConfirmDeleteButton />
                }
            </Datagrid>
        </List>
    )
}

export default DemoVideosCategoriesList
